import {RouteProps} from 'react-router-dom'
import {Login} from '@pages/login/Login.tsx'
import {ResetPassword} from '@/pages/reset-password/ResetPassword'
import {ForgotPassword} from '@/pages/forgot-password/ForgotPassword'
import {SetPasswordByInvite} from '@/pages/set-password-by-invite/SetPasswordByInvite'
import {CreateUser} from '@/pages/create-user/CreateUser'
import {UsersRoute} from '@/route-guards/users-route/UsersRoute'
import {Users} from '@/pages/users/Users'
import {UserDetails} from '@pages/user-details/UserDetails.tsx'
import {UserDetailsInformation} from '@pages/user-details-information/UserDetailsInformation.tsx'
import {UserDetailsAccessProfile} from '@/features/users/components/user-details-access-profile/UserDetailAccessProfile'
import {UserDetailsAvailability} from '@pages/user-details-availability/UserDetailsAvailability.tsx'
import {UserDetailsEvents} from '@pages/user-details-events/UserDetailsEvents.tsx'
import {PatientsRoute} from '@route-guards/patients-route/PatientsRoute.tsx'
import {Patients} from '@pages/patients/Patients.tsx'
import {CreatePatient} from '@/pages/create-patient/CreatePatient'
import {TreatmentRequestsAll} from '@pages/treatment-requests-all/TreatmentRequestsAll.tsx'
import {CreateTreatmentRequest} from '@pages/create-treatment-request/CreateTreatmentRequest.tsx'
import {PatientDetailsInformation} from '@/pages/patient-details-information/PatientDetailsInformation.tsx'
import {TreatmentRequestsInReview} from '@pages/treatment-requests-in-review/TreatmentRequestsInReview.tsx'
import {TreatmentRequestsWaitingList} from '@pages/treatment-requests-waiting-list/TreatmentRequestsWaitingList.tsx'
import {TreatmentRequestsInProgress} from '@pages/treatment-requests-in-progress/TreatmentRequestsInProgress.tsx'
import {TreatmentRequestsAccepted} from '@pages/treatment-requests-accepted/TreatmentRequestsAccepted.tsx'
import {TreatmentRequestsRejected} from '@pages/treatment-requests-rejected/TreatmentRequestsRejected.tsx'
import {TreatmentRequestsRoute} from '@/route-guards/treatment-requests-route/TreatmentRequestsRoute'
import {TreatmentRequestDetails} from '@/pages/treatment-request-details/TreatmentRequestDetails'
import {EmailVerificationRoute} from '@/route-guards/email-verification-route/EmailVerificationRoute'
import {PatientDetailsRoute} from '@/route-guards/patient-details-route/PatientDetailsRoute'
import {CreateMedicalReport} from '@/pages/create-medical-report/CreateMedicalReport'
import {MedicalRecord} from '@/pages/medical-record/MedicalRecord'
import {EditMedicalReport} from '@/pages/edit-medical-report/EditMedicalReport'
import {ProjectsRoute} from '@route-guards/projects-route/ProjectsRoute.tsx'
import {Projects} from '@pages/projects/Projects.tsx'
import {CreateProject} from '@pages/create-project/CreateProject.tsx'
import {SiarExportHistory} from '@/pages/siar-export-history/SiarExportHistory'
import {ActivityReportHistory} from '@/pages/activity-report-history/ActivityReportHistory'
import {AgendaRoute} from '@/route-guards/agenda-route/AgendaRoute'
import {Agenda} from '@/pages/agenda/Agenda'
import {ProjectDetailsRoute} from '@/route-guards/project-details-route/ProjectDetailsRoute'
import {ProjectRenew} from '@/pages/project-renew/ProjectRenew'
import {ProjectDetailsScalesTests} from '@/pages/project-details-scales-tests/ProjectDetailsScalesTests'
import {ProjectDetailsNotes} from '@/pages/project-details-notes/ProjectDetailsNotes'
import {ProjectDetailsLogs} from '@/pages/project-details-logs/ProjectDetailsLogs'
import {ProjectDetailsOtherData} from '@/pages/project-details-other-data/ProjectDetailsOtherData'
import {ProjectDetailsDisabilityProfile} from '@/pages/project-details-disability-profile/ProjectDetailsDisabilityProfile'
import {ProjectDetailsDiagnosesFacilities} from '@/pages/project-details-diagnoses-facilities/ProjectDetailsDiagnosesFacilities'
import {ProjectDetailsProjectData} from '@/pages/project-details-project-data/ProjectDetailsProjectData'
import {AccessesTable} from '@/pages/accesses-table/AccessesTable'
import {AccessesRoute} from '@/route-guards/accesses-route/AccessesRoute'
import {CreatePlannedAccesses} from '@/pages/create-planned-accesses/CreatePlannedAccesses'
import {ProjectDetailsAccessAbsence} from '@/pages/project-details-access-absence/ProjectDetailsAccessAbsence'
import {UserGroupsRoute} from '@/route-guards/user-groups-route/UserGroupsRoute'
import {UserGroups} from '@/pages/user-groups/UserGroups'
import {EditPlannedAccesses} from '@/pages/edit-planned-accesses/EditPlannedAccesses'
import {CompanyInfo} from '@/pages/company-info/CompanyInfo'
import {CompanyInfoRoute} from '@/route-guards/company-info-route/CompanyInfoRoute'
import {DashboardOperational} from '@/pages/dashboard-operational/DashboardOperational'
import {DashboardConsultant} from '@/pages/dashboard-consultant/DashboardConsultant'
import {DashboardEconomic} from '@/pages/dashboard-economic/DashboardEconomic'
import {ProjectTransform} from '@/pages/project-transform/ProjectTransform'
import {ProjectEarlyClosing} from '@/pages/project-early-closing/ProjectEarlyClosing'
import {ProjectExtendsCycle} from '@/pages/project-extends-cycle/ProjectExtendsCycle'
import {BudgetRoute} from '@/route-guards/budget-route/BudgetRoute'
import {BudgetExternalCosts} from '@/pages/budget-external-costs/BudgetExternalCosts'
import {BudgetProjects} from '@/pages/budget-projects/BudgetProjects'
import {BudgetAccessRates} from '@/pages/budget-access-rates/BudgetAccessRates'
import {Home} from '@/pages/home/Home'
import {TreatmentRequestDetailsRoute} from '@/route-guards/treatment-request-details-route/TreatmentRequestDetailsRoute'
import {AccessesValidator} from '@/pages/accesses-validator/AccessesValidator'
import {ReferringSpecialists} from '@/pages/referring-specialists/ReferringSpecialists'
import {PatientDetailsEvents} from '@/pages/patient-details-events/PatientDetailsEvents'
import {ProjectReopening} from '@/pages/project-reopening/ProjectReopening'
import {MailerRoute} from '@/route-guards/mailer-route/MailerRoute'
import {Mailer} from '@/pages/mailer/Mailer'
import {RequestAccountDeletion} from '@/pages/request-account-deletion/RequestAccountDeletion'
import {PrivacyPolicy} from '@/pages/privacy-policy/PrivacyPolicy'

export const routes = {
    LOGIN: {
        path: '/login',
        element: <Login />
    },
    FORGOT_PASSWORD: {
        path: '/forgot-password',
        element: <ForgotPassword />
    },
    RESET_PASSWORD: {
        path: '/reset-password',
        element: <ResetPassword />
    },
    SET_PASSWORD: {
        path: '/set-password',
        element: <SetPasswordByInvite />
    },

    HOME: {
        path: '/',
        element: <Home />,
        handle: {
            path: '/',
            paramName: '',
            name: 'commons:home'
        }
    },

    DASHBOARD: {
        path: '/dashboard',
        handle: {
            path: '/dashboard',
            paramName: '',
            name: 'commons:dashboard'
        }
    },
    DASHBOARD_OPERATIONAL: {
        path: 'operational',
        element: <DashboardOperational />,
        handle: {
            path: '/dashboard/operational',
            paramName: '',
            name: 'dashboard:operational'
        }
    },
    DASHBOARD_CONSULTANT: {
        path: 'consultant',
        element: <DashboardConsultant />,
        handle: {
            path: '/dashboard/consultant',
            paramName: '',
            name: 'dashboard:consultant'
        }
    },
    DASHBOARD_ECONOMIC: {
        path: 'economic',
        element: <DashboardEconomic />,
        handle: {
            path: '/dashboard/economic',
            paramName: '',
            name: 'dashboard:economic'
        }
    },

    AGENDA_ROUTE: {
        path: '/agenda',
        element: <AgendaRoute />,
        handle: {
            path: '/agenda',
            paramName: '',
            name: 'agenda:title'
        }
    },
    AGENDA: {
        path: '/agenda/:entity/:view?/:date?',
        element: <Agenda />
    },
    BUDGET_ROUTE: {
        path: '/budget',
        element: <BudgetRoute />,
        handle: {
            path: '/budget',
            paramName: '',
            name: 'budget:title'
        }
    },
    BUDGET_PROJECTS: {
        path: 'projects',
        element: <BudgetProjects />,
        handle: {
            path: '/budget/projects',
            paramName: '',
            name: 'budget:projects_title'
        }
    },
    BUDGET_EXTERNAL_COSTS: {
        path: 'external-costs',
        element: <BudgetExternalCosts />,
        handle: {
            path: '/budget/external-costs',
            paramName: '',
            name: 'budget:external_costs_title'
        }
    },
    BUDGET_ACCESS_RATES: {
        path: 'access-rates',
        element: <BudgetAccessRates />,
        handle: {
            path: '/budget/access-rates',
            paramName: '',
            name: 'budget:access_rates_title'
        }
    },
    EMAIL_VERIFICATION_ROUTE: {
        path: '/users/:id/email-verification',
        element: <EmailVerificationRoute />,
        handle: {
            path: '/users/:id/email-verification',
            paramName: 'id'
        }
    },
    PATIENTS_ROUTE: {
        path: '/patients',
        element: <PatientsRoute />,
        handle: {
            path: '/patients',
            paramName: '',
            name: 'commons:patients'
        }
    },
    PATIENTS: {
        element: <Patients />,
        index: true
    },
    PATIENT_DETAILS_ROUTE: {
        path: ':id',
        element: <PatientDetailsRoute />,
        handle: {
            path: '/patients/:id',
            paramName: 'id'
        }
    },
    CREATE_PATIENT: {
        path: 'create',
        element: <CreatePatient />,
        handle: {
            path: '/patients/create',
            paramName: '',
            name: 'commons:add_patient'
        }
    },
    PATIENT_DETAILS_INFORMATION: {
        path: 'information',
        element: <PatientDetailsInformation />,
        handle: {
            path: '/patients/:id/information',
            paramName: 'id',
            name: 'users:information'
        }
    },
    PATIENT_DETAILS_MEDICAL_RECORDS: {
        path: 'medical-record',
        element: <MedicalRecord />,
        handle: {
            path: '/patients/:id/medical-record',
            paramName: 'id',
            name: 'global_search:medical_record'
        }
    },
    PATIENT_DETAILS_EVENTS: {
        path: 'events',
        element: <PatientDetailsEvents />,
        handle: {
            path: '/patients/:id/events',
            paramName: 'id',
            name: 'patients:visits_tab_title'
        }
    },
    CREATE_MEDICAL_REPORT: {
        path: '/patients/:id/medical-record/create',
        element: <CreateMedicalReport />,
        handle: {
            path: '/patients/:id/medical-record/create',
            paramName: 'id',
            name: 'commons:add_report'
        }
    },
    EDIT_MEDICAL_REPORT: {
        path: '/patients/:id/medical-record/:medicalReportId',
        element: <EditMedicalReport />,
        handle: {
            path: '/patients/:id/medical-record/:medicalReportId',
            paramName: 'medicalReportId',
            name: 'medical_records:edit_page_title'
        }
    },
    TREATMENT_REQUEST_DETAILS_ROUTE: {
        path: ':id',
        element: <TreatmentRequestDetailsRoute />,
        handle: {
            path: '/treatment-requests/:id',
            paramName: 'id'
        }
    },
    TREATMENT_REQUEST_DETAILS: {
        element: <TreatmentRequestDetails />,
        index: true
    },
    TREATMENT_REQUESTS_ROUTE: {
        path: '/treatment-requests',
        element: <TreatmentRequestsRoute />,
        handle: {
            path: '/treatment-requests',
            paramName: '',
            name: 'commons:treatment_requests'
        }
    },
    TREATMENT_REQUESTS_ALL: {
        element: <TreatmentRequestsAll />,
        index: true,
        handle: {
            path: '/treatment-requests',
            paramName: '',
            name: 'treatment_requests:status_all'
        }
    },
    TREATMENT_REQUESTS_IN_REVIEW: {
        path: 'in-review',
        element: <TreatmentRequestsInReview />,
        handle: {
            path: '/treatment-requests/in-review',
            paramName: '',
            name: 'treatment_requests:status_in_review'
        }
    },
    TREATMENT_REQUESTS_WAITING_LIST: {
        path: 'waiting-list',
        element: <TreatmentRequestsWaitingList />,
        handle: {
            path: '/treatment-requests/waiting-list',
            paramName: '',
            name: 'treatment_requests:status_waiting_list'
        }
    },
    TREATMENT_REQUESTS_IN_PROGRESS: {
        path: 'in-progress',
        element: <TreatmentRequestsInProgress />,
        handle: {
            path: '/treatment-requests/in-progress',
            paramName: '',
            name: 'treatment_requests:status_in_progress'
        }
    },
    TREATMENT_REQUESTS_ACCEPTED: {
        path: 'accepted',
        element: <TreatmentRequestsAccepted />,
        handle: {
            path: '/treatment-requests/accepted',
            paramName: '',
            name: 'treatment_requests:status_accepted_other'
        }
    },
    TREATMENT_REQUESTS_REJECTED: {
        path: 'rejected',
        element: <TreatmentRequestsRejected />,
        handle: {
            path: '/treatment-requests/rejected',
            paramName: '',
            name: 'treatment_requests:status_rejected_other'
        }
    },
    CREATE_TREATMENT_REQUEST: {
        path: 'create',
        element: <CreateTreatmentRequest />,
        handle: {
            path: '/treatment-requests/create',
            paramName: '',
            name: 'treatment_requests:add_treatment_requests_title'
        }
    },
    USERS_ROUTE: {
        path: '/users',
        element: <UsersRoute />,
        handle: {
            path: '/users',
            paramName: '',
            name: 'commons:users'
        }
    },
    USERS: {
        element: <Users />,
        index: true
    },
    USER_DETAILS: {
        path: ':id',
        element: <UserDetails />,
        handle: {
            path: '/users/:id',
            paramName: 'id'
        }
    },
    USER_DETAILS_ACCESS_PROFILE: {
        path: 'access-profile',
        element: <UserDetailsAccessProfile />,
        handle: {
            path: '/users/:id/access-profile',
            paramName: 'id',
            name: 'users:access_profile'
        }
    },
    USER_DETAILS_INFORMATION: {
        path: 'information',
        element: <UserDetailsInformation />,
        handle: {
            path: '/users/:id/information',
            paramName: 'id',
            name: 'users:information'
        }
    },
    USER_DETAILS_AVAILABILITY: {
        path: 'availability',
        element: <UserDetailsAvailability />,
        handle: {
            path: '/users/:id/availability',
            paramName: 'id',
            name: 'users:availability'
        }
    },
    USER_DETAILS_EVENTS: {
        path: 'events',
        element: <UserDetailsEvents />,
        handle: {
            path: '/users/:id/events',
            paramName: 'id',
            name: 'users:visits_tab_title'
        }
    },
    CREATE_USER: {
        path: 'create',
        element: <CreateUser />,
        handle: {
            path: '/users/create',
            paramName: '',
            name: 'users:add_user_title'
        }
    },
    USER_GROUPS_ROUTE: {
        path: '/user-groups',
        element: <UserGroupsRoute />,
        handle: {
            path: '/user-groups',
            paramName: '',
            name: 'commons:user_groups'
        }
    },
    USER_GROUPS: {
        element: <UserGroups />,
        index: true
    },
    PROJECTS_ROUTE: {
        path: '/projects',
        element: <ProjectsRoute />,
        handle: {
            path: '/projects',
            paramName: '',
            name: 'projects:breadcrumb'
        }
    },
    PROJECTS: {
        element: <Projects />,
        index: true
    },
    SIAR_EXPORT_HISTORY: {
        path: 'siar-export-history',
        element: <SiarExportHistory />,
        handle: {
            path: '/projects/siar-export-history',
            paramName: '',
            name: 'projects:bulk_siar_export_history_title'
        }
    },
    ACTIVITY_REPORT_HISTORY: {
        path: 'activity-report',
        element: <ActivityReportHistory />,
        handle: {
            path: '/accesses/activity-report',
            paramName: '',
            name: 'activity_report:history_title'
        }
    },
    PROJECT_DETAILS_ROUTE: {
        path: ':id',
        element: <ProjectDetailsRoute />,
        handle: {
            path: '/projects/:id',
            paramName: 'id'
        }
    },
    PROJECT_DETAILS_PROJECT_DATA: {
        path: 'project-data',
        element: <ProjectDetailsProjectData />,
        handle: {
            path: '/projects/:id/project-data',
            paramName: 'id',
            name: 'projects:tab_project_data'
        }
    },
    PROJECT_DETAILS_OTHER_DATA: {
        path: 'other-data',
        element: <ProjectDetailsOtherData />,
        handle: {
            path: '/projects/:id/other-data',
            paramName: 'id',
            name: 'projects:tab_other_data'
        }
    },
    PROJECT_DETAILS_DIAGNOSES_FACILITIES: {
        path: 'diagnoses-facilities',
        element: <ProjectDetailsDiagnosesFacilities />,
        handle: {
            path: '/projects/:id/diagnoses-facilities',
            paramName: 'id',
            name: 'projects:tab_diagnosis_and_facilities'
        }
    },
    PROJECT_DETAILS_DISABILITY_PROFILE: {
        path: 'disability-profile',
        element: <ProjectDetailsDisabilityProfile />,
        handle: {
            path: '/projects/:id/disability-profile',
            paramName: 'id',
            name: 'projects:tab_disability_profile'
        }
    },
    PROJECT_DETAILS_SCALES_TESTS: {
        path: 'scales-tests',
        element: <ProjectDetailsScalesTests />,
        handle: {
            path: '/projects/:id/scales-tests',
            paramName: 'id',
            name: 'projects:tab_scales_and_tests'
        }
    },
    PROJECT_DETAILS_PLANNED_ACCESSES: {
        path: 'planned-accesses',
        element: <ProjectDetailsAccessAbsence />,
        handle: {
            path: '/projects/:id/planned-accesses',
            paramName: 'id',
            name: 'projects:planned_accesses'
        }
    },
    PROJECT_DETAILS_NOTES: {
        path: 'notes',
        element: <ProjectDetailsNotes />,
        handle: {
            path: '/projects/:id/notes',
            paramName: 'id',
            name: 'projects:tab_notes'
        }
    },
    PROJECT_DETAILS_LOGS: {
        path: 'logs',
        element: <ProjectDetailsLogs />,
        handle: {
            path: '/projects/:id/logs',
            paramName: 'id',
            name: 'projects:tab_logs'
        }
    },
    PROJECT_RENEW: {
        path: 'renew',
        element: <ProjectRenew />,
        handle: {
            path: '/projects/:id/renew',
            paramName: 'id',
            name: 'projects:renew_project_title'
        }
    },
    PROJECT_TRANSFORM: {
        path: 'transform',
        element: <ProjectTransform />,
        handle: {
            path: '/projects/:id/transform',
            paramName: 'id',
            name: 'projects:transform_project_title'
        }
    },
    PROJECT_EARLY_CLOSING: {
        path: 'early-closing',
        element: <ProjectEarlyClosing />,
        handle: {
            path: '/projects/:id/early-closing',
            paramName: 'id',
            name: 'projects:project_early_closing_title'
        }
    },
    PROJECT_REOPENING: {
        path: 'reopening',
        element: <ProjectReopening />,
        handle: {
            path: '/projects/:id/reopening',
            paramName: 'id',
            name: 'projects:reopen_project_title'
        }
    },
    PROJECT_EXTENDS_CYCLE: {
        path: 'extends-cycle',
        element: <ProjectExtendsCycle />,
        handle: {
            path: '/projects/:id/extends-cycle',
            paramName: 'id',
            name: 'projects:extends_cycle_title'
        }
    },
    CREATE_PROJECT: {
        path: 'create',
        element: <CreateProject />,
        handle: {
            path: '/projects/create',
            paramName: '',
            name: 'projects:add_new_project'
        }
    },
    ACCESSES_ROUTE: {
        path: '/accesses',
        element: <AccessesRoute />,
        handle: {
            path: '/accesses',
            paramName: '',
            name: 'accesses:title'
        }
    },
    ACCESSES_TABLE: {
        path: 'table',
        element: <AccessesTable />,
        handle: {
            path: '/accesses/table',
            paramName: '',
            name: 'accesses:all_accesses'
        }
    },
    ACCESSES_VALIDATOR: {
        path: 'validator',
        element: <AccessesValidator />,
        handle: {
            path: '/accesses/validator',
            paramName: '',
            name: 'accesses:validator_title'
        }
    },
    CREATE_PLANNED_ACCESSES: {
        path: '/projects/:id/planned-accesses/create',
        element: <CreatePlannedAccesses />,
        handle: {
            path: '/projects/:id/planned-accesses/create',
            paramName: 'id',
            name: 'planned_accesses:create_form_title'
        }
    },
    EDIT_PLANNED_ACCESSES: {
        path: '/projects/:id/planned-accesses/edit',
        element: <EditPlannedAccesses />,
        handle: {
            path: '/projects/:id/planned-accesses/edit',
            paramName: 'id',
            name: 'planned_accesses:edit_planned_accesses'
        }
    },
    COMPANY_INFO_ROUTE: {
        path: '/company-info',
        element: <CompanyInfoRoute />,
        handle: {
            path: '/company-info',
            paramName: '',
            name: 'commons:company_info'
        }
    },
    COMPANY_INFO: {
        element: <CompanyInfo />,
        index: true
    },
    REFERRING_SPECIALIST: {
        path: '/referring-specialists',
        element: <ReferringSpecialists />,
        handle: {
            path: '/referring-specialists'
        }
    },
    MAILER_ROUTE: {
        path: '/mailer',
        element: <MailerRoute />,
        handle: {
            path: '/mailer',
            paramName: '',
            name: 'mailer:title'
        }
    },
    MAILER: {
        element: <Mailer />,
        index: true
    },
    REQUEST_ACCOUNT_DELETION: {
        path: '/request-account-deletion',
        element: <RequestAccountDeletion />
    },
    PRIVACY_POLICY: {
        path: '/privacy-policy',
        element: <PrivacyPolicy />
    }
} as const satisfies Record<string, RouteProps>
